import { render, staticRenderFns } from "./salaryDtl.vue?vue&type=template&id=e6674a36&scoped=true&"
import script from "./salaryDtl.vue?vue&type=script&lang=js&"
export * from "./salaryDtl.vue?vue&type=script&lang=js&"
import style0 from "./salaryDtl.vue?vue&type=style&index=0&id=e6674a36&prod&lang=scss&scoped=true&"
import style1 from "./salaryDtl.vue?vue&type=style&index=1&id=e6674a36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6674a36",
  null
  
)

export default component.exports